<!--
グラフ選択画面
URL：/graph/product
-->

<template>
  <div>
    <v-container>
      <alert :errors="errors" css_class="ma-1"></alert>
      <v-row justify="center" style="text-align: center; margin-top: 10px">
        <v-col cols="auto" style="padding: 0px; width: 155px; height: 70px">
          <v-card-title class="custom-card-title">表示データ：</v-card-title>
        </v-col>
        <v-col cols="auto" style="padding: 0px; width: 280px; height: 70px">
          <v-select
            outlined
            color="#0ddbc7"
            placeholder="表示データを選択して下さい"
            v-model="graphKindName"
            :items="dispDataItems"
            @input="onInput"
            :menu-props="{ maxHeight: '400px', overflowY: 'auto' }"
          ></v-select>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="auto" style="padding: 0px; width: 155px; height: 70px">
          <v-card-title class="custom-card-title">表示年1：</v-card-title>
        </v-col>
        <v-col cols="auto" style="padding: 0px; width: 280px; height: 70px">
          <v-select
            outlined
            color="#0ddbc7"
            v-model="dispYear1"
            :items="selectDispYears1"
          ></v-select>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="auto" style="padding: 0px; width: 155px; height: 70px">
          <v-card-title class="custom-card-title">表示年2：</v-card-title>
        </v-col>
        <v-col cols="auto" style="padding: 0px; width: 280px; height: 70px">
          <v-select
            outlined
            color="#0ddbc7"
            v-model="dispYear2"
            :items="selectDispYears2"
          ></v-select>
        </v-col>
      </v-row>
      <v-row justify="center" style="text-align: center; margin-top: 5px">
        <v-col cols="auto" style="padding: 0px; margin: 5px">
          <v-btn
            color="primary"
            style="font-size: 24px"
            class="ma-2"
            width="200"
            height="50"
            @click="dispGraph"
            >表示</v-btn
          >
        </v-col>
      </v-row>
      <v-divider style="margin: 20px"></v-divider>

      <div v-if="dispFlag.seaarea && graphCategory === 'CATEGORY_PRODUCTIVITY'">
      <v-row justify="center" style="text-align: center; margin-top: 10px">
        <v-col cols="auto" style="padding: 0px; width: 155px; height: 70px">
          <v-card-title class="custom-card-title">海域：</v-card-title>
        </v-col>
        <v-col cols="auto" style="padding: 0px; width: 280px; height: 70px">
          <v-select
            outlined
            color="#0ddbc7"
            v-model="seaArea"
            :items="dispSeaAreaItems"
            @input="onSelectSeaArea"
          ></v-select>
        </v-col>
      </v-row>
      </div>

      <div v-if="dispFlag.producer && this.$store.getters.userGroupIds.includes('root')">
      <v-row justify="center" style="text-align: center; margin-top: 10px">
        <v-col cols="auto" style="padding: 0px; width: 155px; height: 70px">
          <v-card-title class="custom-card-title">生産者：</v-card-title>
        </v-col>
        <v-col cols="auto" style="padding: 0px; width: 280px; height: 70px">
          <v-autocomplete
            outlined
            color="#0ddbc7"
            label="生産者を選択して下さい"
            v-model="selectProducerName"
            :items="dispProducerItems"
            @input="onSelectProducer"
            no-data-text="該当する生産者はいません。"
          ></v-autocomplete>
        </v-col>
      </v-row>
      </div>
      <div v-if="graphCategory === 'CATEGORY_PRODUCTIVITY'">
        <graph-output-productivity ref="graph_op"></graph-output-productivity>
      </div>
      <div v-else>
        <graph-output ref="graph_op"></graph-output>
      </div>
    </v-container>
  </div>
</template>

<script>
import graphOutput from "../../components/graph-sub-contents/graph-output.vue";
import graphOutputProductivity from "../../components/graph-sub-contents/graph-output-productivity.vue";
import Api from "@/logic/api/api.js";
import Alert from "../../components/common/alert.vue";
import AlertBuilder from "../../logic/common/alert-contents";
import valueMapper from "../../logic/common/value-mapper";

export default {
  components: {
    "graph-output": graphOutput,
    "graph-output-productivity": graphOutputProductivity,
    alert: Alert,
  },
  data() {
    this.graphKindName = "";
    this.selectDispYears1 = [];
    this.selectDispYears2 = [];
    this.dispYear1 = "";
    this.dispYear2 = "";

    this.uid = "";
    this.summary_type = "";
    this.summary_year = [];
    this.update_date = "";

    /**
     * グラフ種別
     *   CATEGORY_NORMAL:       通常グラフ      UNLOADING/SHIPPINGのどちらか一方のデータを取得し表示する
     *                                          graph-output.vueを使用する
     *   CATEGORY_PRODUCTIVITY: 生産効率グラフ  生産効率算出のためUNLOADING/SHIPPING両方のデータを取得し表示する
     *                                          graph-output-productivity.vueを使用する
     */
    this.graphCategory = "";

    // 表示・非表示フラグ
    this.dispFlag = {
      // グラフ
      graph: false,
      // 生産者欄
      producer: false,
      // 海域欄
      seaarea: false,
      // 区分(1:通常（二倍体）2:三倍体)切替ボタン
      doubling: false,
    };

    // 生産者選択欄
    this.dispProducerItems = [];
    this.selectProducerName = this.$store.getters.userDisplayName;
    this.selectUid = this.$store.getters.userId;

    this.$nextTick(() => {});

    // 出力メッセージ領域クリア
    this.clearMessage();

    // 表示年1リスト作成(現在からシステム基準年(2021年)までの西暦と和暦を詰める)
    var today = new Date();
    var nowMonth1 = today.getMonth() + 1;
    var nowYear1 = today.getFullYear();
    // 対象年度取得
    if (10 <= nowMonth1 && nowMonth1 <= 12) {
      nowYear1 == nowYear1;
    }
    if (1 <= nowMonth1 && nowMonth1 <= 9) {
      nowYear1 -= 1;
    }
    for (var count1 = 0; count1 <= nowYear1 - 2021; count1++) {
      var nowYearJP1 = "(令和" + (nowYear1 - count1 - 2018) + ")";
      this.selectDispYears1[count1] = nowYear1 - count1 + nowYearJP1 + "年";
    }
    // 表示年2リスト作成(一昨年からシステム基準年(2021年)までの西暦と和暦を詰める)
    var nowMonth2 = today.getMonth() + 1;
    var nowYear2 = today.getFullYear() - 1;
    // 対象年度取得
    if (10 <= nowMonth2 && nowMonth2 <= 12) {
      // 今年度のまま
      nowYear2 == nowYear2;
    }
    if (1 <= nowMonth2 && nowMonth2 <= 9) {
      // 前年度を設定
      nowYear2 -= 1;
    }
    for (var count2 = 0; count2 <= nowYear2 - 2021; count2++) {
      var nowYearJP2 = "(令和" + (nowYear2 - count2 - 2018) + ")";
      this.selectDispYears2[count2] = nowYear2 - count2 + nowYearJP2 + "年";
    }

    // 表示データリストの内容をログインユーザ情報(生産者フラグ/広島県グループ所属)に応じて動的に変更する
    var flagProducer = this.$store.getters.flagProducer;
    var isRootGroup = this.$store.getters.userGroupIds.includes('root');
    var dispDataItems = [];
    if (flagProducer) {
      // 生産者の場合
      dispDataItems = [
        "むき身総出荷量の推移",
        "総水揚げ連数の推移",
        "総生産効率の比較",
        "生産者当たり水揚げ量の比較",
        "生産者当たりむき身出荷量の比較",
        "殻付き出荷個数（生産者当たり）",
        "生産者当たりの生産効率の比較",
      ];
    } else if (isRootGroup) {
      // 管理者の場合
      dispDataItems = [
        "むき身総出荷量の推移",
        "総水揚げ連数の推移",
        "殻付き出荷個数（生産者当たり）",
        "総生産効率の比較",
        "生産者当たりの生産効率の比較",
      ];
    } else {
      dispDataItems = [
        "むき身総出荷量の推移",
        "総水揚げ連数の推移",
        "総生産効率の比較",
      ];
    }

    // 海域
    const dispSeaAreaItems = [
      "全海域",
      "広島湾西部",
      "広島湾北部",
      "広島湾中部",
      "広島湾南部",
      "呉湾",
      "広湾",
      "三津湾",
      "広島県東部",
    ];

    // 採取海域区分（ユーザーが保持している値を設定）
    this.seaArea = dispSeaAreaItems[this.$store.getters.seaArea];

    // 生産者一覧リスト生成
    // 自身を1番目に表示
    this.dispProducerItems.push(this.$store.getters.userDisplayName);

    // ユーザーリストから自身以外を追加
    var haccpUserList = this.$store.getters.haccpUserList;
    for (const user in haccpUserList) {
      if (haccpUserList[user].flagProducer && haccpUserList[user].uid != this.$store.getters.userId) {
        this.dispProducerItems.push(haccpUserList[user].userName);
      }
    }

    return {
      errors: [],
      // 表示データ
      graphKindName: dispDataItems[0],
      // 表示データリスト設定
      dispDataItems: dispDataItems,
      // 表示年1リスト設定
      dispYear1: this.selectDispYears1[0],
      // 表示年2リスト設定
      dispYear2: this.selectDispYears2[0],
      // ユーザーリスト設定
      dispProducerItems: this.dispProducerItems,
      // 海域一覧リスト設定
      dispSeaAreaItems: dispSeaAreaItems,
      // セレクトボックス表示切替
      graphCategory: "CATEGORY_NORMAL",
      // 表示・非表示フラグ
      dispFlag: this.dispFlag,
    };
  },
  methods: {
    /**
     * 選択ボックスの表示・非表示の切り替えおよびグラフ種別の設定
     */
    onInput() {
      this.selectUid = this.$store.getters.userId;
      this.dispFlag = this.resetdispFlag();
      switch (this.graphKindName) {
        case "むき身総出荷量の推移":
        case "総水揚げ連数の推移":
        case "生産者当たり水揚げ量の比較":
        case "生産者当たりむき身出荷量の比較":
          {
            this.graphCategory = "CATEGORY_NORMAL";
            return;
          }
        case "殻付き出荷個数（生産者当たり）":
          {
            this.graphCategory = "CATEGORY_NORMAL";
            this.dispFlag.producer = true;
            this.dispFlag.doubling = true;
            return;
          }
        case "総生産効率の比較":
          {
            this.graphCategory = "CATEGORY_PRODUCTIVITY";
            this.dispFlag.seaarea = true;
            return;
          }
        case "生産者当たりの生産効率の比較":
          {
            this.graphCategory = "CATEGORY_PRODUCTIVITY";
            this.dispFlag.producer = true;
            this.dispFlag.seaarea = true;
            return;
          }
      }
    },
    /**
     * 生産集計情報を取得する
     */
    getSummaryData() {
      // 各表示年を集計年リストに格納
      var summaryYear1 = { comparison_year: "" };
      var summaryYear2 = { comparison_year: "" };
      var summaryYear = [];
      summaryYear1.comparison_year = this.dispYear1.slice(0, 4);
      summaryYear.push(summaryYear1);
      summaryYear2.comparison_year = this.dispYear2.slice(0, 4);
      summaryYear.push(summaryYear2);

      // 表示対象種別毎に取得用パラメータ生成
      switch (this.graphKindName) {
        case "むき身総出荷量の推移":
          return {
            uid: "",
            summary_type: "SHIPPING",
            summary_year: summaryYear,
            harvest_sea_area: 0,
          };
        case "生産者当たり水揚げ量の比較":
          return {
            // ログイン者のユーザIDを指定
            uid: "",
            summary_type: "UNLOADING",
            summary_year: summaryYear,
            harvest_sea_area: 0,
          };
        case "生産者当たりむき身出荷量の比較":
          return {
            // ログイン者のユーザIDを指定
            uid: "",
            summary_type: "SHIPPING",
            summary_year: summaryYear,
            harvest_sea_area: 0,
          };
        case "総水揚げ連数の推移":
          return {
            uid: "",
            summary_type: "UNLOADING",
            summary_year: summaryYear,
            harvest_sea_area: 0,
          };
        case "殻付き出荷個数（生産者当たり）":
          return {
            // 選択した生産者のIDを指定
            uid: this.selectUid,
            summary_type: "SHIPPING",
            summary_year: summaryYear,
            harvest_sea_area: 0,
          };
        case "総生産効率の比較":
        case "生産者当たりの生産効率の比較":
          return {
            summary_year: summaryYear,
            harvest_sea_area: this.dispSeaAreaItems.indexOf(this.seaArea),
          };
      }
    },
    /**
     * グラフを表示する
     */
    dispGraph() {
      // メッセージ領域をクリアする
      this.clearMessage();

      // 入力値チェック
      if (this.graphKindName == "") {
        this.showMessage(AlertBuilder.error("表示データを選択してください"));
      } else {
        switch (this.graphCategory) {
          case "CATEGORY_NORMAL":
            if (this.checkDispYear()) {
              // グラフ出力フラグON
              this.dispFlag.graph = true;

              // グラフ出力用のデータを収集する
              this.getDataNormal();
            }
            break;
          case "CATEGORY_PRODUCTIVITY":
            if (this.checkDispYear()) {
              // グラフ出力フラグON
              this.dispFlag.graph = true;

              // グラフ出力用のデータを収集する
              this.getDataProductivity();
            }
            break;
        }
      }
    },
    /**
     * グラフ出力用のデータを収集する
     */
    getDataNormal() {
      // 画面から指定された表示データ及び、2年分の表示年の指定有無チェック
      if (this.graphKindName) {
        // 生産集計情報取得APIを呼ぶ
        let getSummaryDataUrl = "/haccp/record/summary";
        let postData = this.getSummaryData();

        this.$store.commit("setWaiting", true);

        Api.call(getSummaryDataUrl, postData)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            this.uid = result.uid;
            this.summary_type = result.summary_type;
            this.summary_data = result.summary_data;
            this.product_record_update_date = result.product_record_update_date;
            // グラフ出力用のデータを設定する
            this.setData();
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
              .map({
                400: AlertBuilder.error("取得に失敗しました"),
                401: AlertBuilder.invalid(),
                403: AlertBuilder.error("権限がありません"),
              })
              .getOrElse(error.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(error);
            } else {
              this.showMessage(message);
            }
          });
      }
    },
    /**
     * グラフ出力用のデータを収集する(生産効率向け)
     */
    getDataProductivity() {
      if (this.graphKindName) {
        // 生産集計情報取得APIを呼ぶ
        var getSummaryDataUrl = "/haccp/record/summary/productivity";

        // UNLOADING/SHIPPING両方を取得する
        this.summary_data = [];
        let postData = this.getSummaryData();
        this.$store.commit("setWaiting", true);
        Api.call(getSummaryDataUrl, postData)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            this.summary_data = result.summary_data;

            // グラフ出力用のデータを設定する
            this.setDataProductivity();
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
              .map({
                400: AlertBuilder.error("取得に失敗しました"),
                401: AlertBuilder.invalid(),
                403: AlertBuilder.error("権限がありません"),
              })
              .getOrElse(error.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(error);
            } else {
              this.showMessage(message);
            }
          });
      }
    },
    /**
     * グラフ出力用のデータを設定する
     */
    setData() {

      // 画面から指定された表示データ及び、2年分の表示年の指定有無チェック
      this.checkComparisonYear(this.summary_data)

      // グラフ情報を設定する
      this.$refs.graph_op.setDataMonth(
        // 表示データ(グラフの種類)
        this.graphKindName,
        // 表示年1
        this.dispYear1.slice(0, 4),
        // 表示年2
        this.dispYear2.slice(0, 4),
        // ユーザーID
        this.selectUid,
        // 集計種別
        this.summary_type,
        // API取得集計データ
        this.summary_data,
        // 生産情報更新日時
        this.product_record_update_date,
      );
    },
    /**
     * グラフ出力用のデータを設定する(生産効率)
     */
    setDataProductivity() {

      // 画面から指定された表示データ及び、2年分の表示年の指定有無チェック
      // this.summary_data[0]：UNLOADING 水揚げデータ
      // this.summary_data[1]：SHIPPING  出荷データ
      // 生産効率の場合はすべてのデータの集計を行うため、チェックを行わない
      // this.checkComparisonYear(this.summary_data[0])

      // グラフ情報を設定する
      this.$refs.graph_op.setDataMonth(
        // 表示データ(グラフの種類)
        this.graphKindName,
        // 表示年1
        this.dispYear1.slice(0, 4),
        // 表示年2
        this.dispYear2.slice(0, 4),
        // ユーザーID
        this.selectUid,
        // API取得集計データ
        this.summary_data,
      );
    },
    /**
     * 海域および表示グラフを更新する(生産効率)
     */
    onSelectSeaArea() {
      // メッセージ領域をクリアする
      this.clearMessage();

      // グラフ出力フラグON
      this.dispFlag.graph = true;

      // グラフデータを収集・表示
      this.getDataProductivity();

      // Storeデータ更新
      this.$store.commit("setSeaArea", this.dispSeaAreaItems.indexOf(this.seaArea) || 0);

      // 採取海域区分更新
      this.updateSeaArea();
    },
    /**
     * 生産者UIDおよび表示グラフを更新する
     */
    onSelectProducer() {
      var haccpUserList = this.$store.getters.haccpUserList;
      var index = haccpUserList.map(el => el.userName).indexOf(this.selectProducerName);
      this.selectUid = haccpUserList[index].uid;

      // メッセージ領域をクリアする
      this.clearMessage();
      // グラフ出力フラグON
      this.dispFlag.graph = true;
      // グラフデータを収集・表示
      switch (this.graphCategory) {
        case "CATEGORY_NORMAL":
          this.getDataNormal();
          break;
        case "CATEGORY_PRODUCTIVITY":
          this.getDataProductivity();
          break;
      }
    },
    /**
     * 表示年1及び、表示年2の相関チェック
     */
    checkDispYear() {
      if (this.graphKindName != "" && this.dispYear1 > this.dispYear2) {
        return true;
      } else {
        if (this.dispYear1 <= this.dispYear2) {
          this.showMessage(
            AlertBuilder.error(
              "表示年1は、表示年2よりも未来年を選択してください"
            )
          );
        }
        return false;
      }
    },
    /**
     * 画面から指定された表示データ及び、2年分の表示年の指定有無チェック
     */
    checkComparisonYear(summarydata) {
      if (this.graphKindName == "" || summarydata.length == 0) {
        this.showMessage(AlertBuilder.error("対象データが存在しません"));
        this.dispFlag.graph = false;
      }

      for (var row of summarydata) {
        if (
          (row.comparison_year != this.dispYear1.slice(0, 4)) &&
          (row.comparison_year != Number(this.dispYear1.slice(0, 4)) + 1)
        ) {
          this.showMessage(AlertBuilder.error("対象データが存在しません"));
          this.dispFlag.graph = false;
        }
        break;
      }
    },
    /**
     * 表示・非表示フラグリセット
     */
    resetdispFlag() {
      return {
        graph: false,
        producer: false,
        seaarea: false,
        doubling: false,
      };
    },
    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
    /**
     * 採取海域区分更新
     */
    updateSeaArea() {
      // 送信データを作成する
      const postData = {
        update_request: [{
            uid: this.$store.getters.userId,
            sea_area: this.$store.getters.seaArea,
        },
      ]};

      this.clearMessage();
      this.$nextTick(() => {
        // 採取海域区分を更新する
        this.$store.commit("setWaiting", true);
        Api.call("/admin/user/seaarea/update", postData)
              .then((result) => {
                this.$store.commit("setWaiting", false);
                const message = valueMapper
                  .map({
                    failed: AlertBuilder.error("採取海域区分の更新に失敗しました"),
                  })
                  .get(result.message);
                if (message) {
                  this.errors.push(message);
                }
              })
          .catch((result) => {
            this.$store.commit("setWaiting", false);
            Api.resolve(result);
          });
      });
    },
  },
};
</script>

<style></style>
